/* Framework */
export const PAGE_CONTENT_ID = 'page-content'
export const PAGE_CONTENT_LOADING_ID = 'page-content-loading'
export const SIDEBAR_LINK_PREFIX = 'sidebar-link-'
export const SIDEBAR_SUBMENU_TOGGLE_SUFFIX = '-toggle'

/* Installation System Protocol Page */
export const SYSTEM_PROTOCOL_FILTER_ID = 'system-protocol-page-filters'
export const SYSTEM_PROTOCOL_LOGS_ID = 'system-protocol-page-logs'

/* Installation Rights Administration Page */
export const RIGHTS_ADMINISTRATION_PERMISSIONS_ID = 'rights-administration-page-permissions'
export const RIGHTS_ADMINISTRATION_KEYS_ID = 'rights-administration-page-keys'

/* Installation Documentation Page*/
export const DOCUMENTATION_SEARCH_ID = 'documents-page-search'
export const DOCUMENTATION_INSTALLATION_DOCUMENTS_ID = 'documents-page-installation-documents'
export const DOCUMENTATION_GAPP_REPORTS_ID = 'documents-page-gap-reports'

/* User Page */
export const USER_PROFILE_DETAILS_ID = 'user-profile-details'
export const USER_PROFILE_DATA_ID = 'user-profile-data'
export const USER_PROFILE_MAP_ID = 'user-profile-map'
export const API_ACCESS_ID = 'api-access'
export const API_ACCESS_CREATE_BUTTON_ID = 'api-access-create-button'
export const API_ACCESS_CLIENT_ID = 'api-access-client-id'
export const API_ACCESS_DELETE_BUTTON_ID = 'api-access-delete-button'

/* Contact Page */
export const CONTACT_PAGE_TECHNICAL_SUPPORT_ID = 'contact-page-technical-support'
export const CONTACT_PAGE_KNOWLEDGE_BASE_ID = 'contact-page-knowledge-base'
export const CONTACT_PAGE_TICKET_SUPPORT_ID = 'contact-page-ticket-support'
export const CONTACT_PAGE_PRIVATE_CUSTOMER_SUPPORT_ID = 'contact-page-private-customer-support'
export const CONTACT_PAGE_KNOWLEDGE_BASE_BUTTON_ID = 'contact-page-knowledge-base-button'
export const CONTACT_PAGE_TICKET_SUPPORT_BUTTON_ID = 'contact-page-ticket-support-button'

/* Dashboard Page */
/* Editor */
export const DASHBOARD_EDITOR_BUTTON_ID = 'dashboard-editor-button'
export const DASHBOARD_EDITOR_INSTRUCTIONS_PAGE_ID = 'dashboard-editor-instructions-page'
export const DASHBOARD_EDITOR_CONTENT_PAGE_ID = 'dashboard-editor-content-page'
export const DASHBOARD_EDITOR_NEXT_PAGE_BUTTON_ID = 'dashboard-editor-next-page-button'
export const DASHBOARD_EDITOR_SAVE_BUTTON_ID = 'dashboard-editor-save-button'
export const DASHBOARD_EDITOR_HIDDEN_BUTTON_ID = 'dashboard-editor-hidden-button-id'
export const DASHBOARD_EDITOR_VISIBLE_BUTTON_ID = 'dashboard-editor-visible-button-id'
export const DASHBOARD_EDITOR_CURRENT_VALUES_AREA_ID = 'dashboard-editor-current-values-area'
export const DASHBOARD_EDITOR_SUMMARY_AREA_ID = 'dashboard-editor-summary-area'
export const DASHBOARD_EDITOR_WIDGETS_AREA_ID = 'dashboard-editor-widgets-area'
export const DASHBOARD_EDITOR_SYSTEM_LOG_AND_MAP_AREA_ID = 'dashboard-editor-log-and-map-area'
export const DASHBOARD_EDITOR_STATISTICS_AREA_ID = 'dashboard-editor-statistics-area'
export const DASHBOARD_EDITOR_SAVINGS_AREA_ID = 'dashboard-editor-savings-area'
export const DASHBOARD_EDITOR_DYNAMIC_POWER_PRICE_WIDGET_ID = 'dashboard-editor-dynamic-power-price-widget'
export const DASHBOARD_EDITOR_BATTERY_WIDGET_ID = 'dashboard-editor-battery-widget'
export const DASHBOARD_EDITOR_WALLBOX_WIDGET_ID = 'dashboard-editor-wallbox-widget'
export const DASHBOARD_EDITOR_WEATHER_FORECAST_WIDGET_ID = 'dashboard-editor-weather-forecast-widget'

/* Overview */
export const OWNER_OVERVIEW_INSTALLATION_TABLE_ID = 'owner-installation-table-view'
export const SERVICE_INSTALLATION_TABLE_VIEW_ID = 'installation-table-view'

/* Dashboard */
export const DASHBOARD_LIVE_VIEW_ID = 'dashboard-live-view'
// Append a LiveItemType value (e.g. pvHomePower, networkHomePower, battery, evsesSub).
export const DASHBOARD_LIVE_VIEW_ITEM_PREFIX = 'dashboard-live-view-item-'
// Append a LiveItemType value; the old (regular) and the new (GUI) live view use separate prefixes so a test can tell them apart.
export const DASHBOARD_LIVE_VIEW_VALUE_PREFIX = 'dashboard-live-view-value-'
export const DASHBOARD_GUI_LIVE_VIEW_VALUE_PREFIX = 'dashboard-gui-live-view-value-'
export const DASHBOARD_LIVE_VIEW_SWITCH_BUTTON_ID = 'dashboard-live-view-switch-button'
export const DASHBOARD_BATTERY_WIDGET_ID = 'dashboard-battery-widget'
export const DASHBOARD_WALLBOX_WIDGET_ID = 'dashboard-wallbox-widget'
export const DASHBOARD_DYNAMIC_POWER_PRICE_WIDGET_ID = 'dashboard-dynamic-power-price-widget'
export const DASHBOARD_WEATHER_FORECAST_WIDGET_ID = 'dashboard-weather-forecast-widget'
export const DASHBOARD_SUMMARY_DATA_ID = 'dashboard-summary-data'
export const DASHBOARD_SUMMARY_DATA_DPP_CARD_ID = 'dashboard-summary-data-dpp-card'
export const DASHBOARD_SUMMARY_DATA_PRODUCTION_CARD_ID = 'dashboard-summary-data-production-card'
export const DASHBOARD_SUMMARY_DATA_NETWORK_CARD_ID = 'dashboard-summary-data-network-card'
export const DASHBOARD_SUMMARY_DATA_CO2_CARD_ID = 'dashboard-summary-data-co2-card'
export const DASHBOARD_SYSTEM_PROTOCOL_ID = 'dashboard-system-protocol'
export const DASHBOARD_COST_SAVINGS_ID = 'dashboard-cost-savings'
export const DASHBOARD_SYSTEM_CHARTS_ID = 'dashboard-system-charts'
export const DASHBOARD_POC_SYSTEM_CHARTS_ID = 'dashboard-poc-system-charts'
export const DASHBOARD_PRODUCTION_PIE_CHART_ID = 'dashboard-production-pie-chart'
export const DASHBOARD_POC_PRODUCTION_PIE_CHART_ID = 'dashboard-poc-production-pie-chart'
// Pie chart legend value hook (PieChartLegend.tsx) — append the stable trace key (data key).
export const PIE_CHART_LEGEND_VALUE_PREFIX = 'pie-chart-legend-value-'
export const DASHBOARD_SAVINGS_PIE_CHART_ID = 'dashboard-savings-pie-chart'
export const DASHBOARD_POC_SAVINGS_PIE_CHART_ID = 'dashboard-poc-savings-pie-chart'
export const DASHBOARD_HOUSE_CONSUMPTION_PIE_CHART_ID = 'dashboard-house-consumption-pie-chart'
export const DASHBOARD_POC_HOUSE_CONSUMPTION_PIE_CHART_ID = 'dashboard-poc-house-consumption-pie-chart'
export const DASHBOARD_PERFORMANCE_VALUE_CHART_ID = 'dashboard-performance-value-chart'
export const CHART_LOADING_BACKDROP_ID = 'chart-loading-backdrop'
export const DASHBOARD_BUILDING_CHART_BUTTON_ID = 'dashboard-building-chart-button'
export const DASHBOARD_DIRECT_CONSUMPTION_CHART_BUTTON_ID = 'dashboard-direct-consumption-chart-button'
export const DASHBOARD_HOME_CONSUMPTION_CHART_ID = 'dashboard-home-consumption-chart'
export const DASHBOARD_PRODUCTION_CONSUMPTION_CHART_ID = 'dashboard-production-consumption-chart'
